// extracted by mini-css-extract-plugin
export var active = "_cj-2";
export var recordingDot = "_cj-1";
export var recordingIndicator = "_cj-0";